import React from "react";

const FAQ = () => {
    return (
        <div>
            <h1>FAQ</h1>
            <p>Frequently Asked Questions.</p>
        </div>
    );
};

export default FAQ;
